export class CustomLayoutSchoolDefault {    
    Id: number;
    Layout_Id: number;
    School_Domain: number;
    LayoutType_Id: number;
    SchoolName: string;
   }